import React from "react";
// SCSS
import "./teamInfo.scss";

const about = () => (
  <div className="team__info flex-center">
    <div>
      <h4 className="font20 weight800">Planificación que convierte ideas en magia</h4>
      <p className="font12 weight500">
      Creo firmemente que el 90% del éxito de un evento radica en una planificación meticulosa; el resto es disfrutar la magia de lo planeado. Me encantará ser parte de tu historia y hacer realidad tu visión.
      ¡Hagamos juntos algo memorable!
      </p>
    </div>
  </div>
);

export default about;
